module.exports = __webpack_public_path__ + "img/different-cuisines.04d0e8f9.jpg";